import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StakeHolder from "../components/StakeHolder";


const StakeHolderPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Stakeholder" />

        {/* BankDocuments */}
        <StakeHolder />


      </MasterLayout>
    </>
  );
};

export default StakeHolderPage;
